<template>
  <b-dropdown class="lang" variant="white" toggle-class="">
    <template v-slot:button-content>
      <img class :src="flag" height="16" />
      <!-- {{ text | translate }} -->
    </template>
    <b-dropdown-item
      class="notify-item"
      v-for="(entry, i) in languages"
      :key="`Lang${i}`"
      :value="entry"
      @click="setLanguage(entry.language, entry.title, entry.flag)"
      :class="{ active: language === entry.language }"
    >
      <img :src="`${entry.flag}`" alt="user-image" class="mr-1" height="12" />
      <span class="align-middle">{{ entry.title | translate }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: { request: { type: Object, required: true }, indent: { type: String, required: false } },
  data() {
    return {
      language: null,
      text: null,
      flag: null,
      value: null,
    };
  },
  computed: {
    languages() {
      return [
        {
          flag: require("@/assets/images/flags/tr.jpg"),
          language: "tr",
          title: { tr: "Türkçe", en: "Turkish", fr: "Turkish", de: "Turkish" },
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: { tr: "İngilizce", en: "English", fr: "English", de: "English" },
        },

        {
          flag: require("@/assets/images/flags/de.jpg"),
          language: "de",
          title: { tr: "Almanca", en: "German", fr: "German", de: "Deutsch" },
        },
      ];
    },
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === this.currentLanguage);
    this.text = this.value?.title;
    this.flag = this.value?.flag;

    if (this.indent) {
      this.request.query = { ...this.request.query, [`"${this.indent}.language"`]: { value: this.currentLanguage, isObject: true } };
    } else {
      this.request.query = { ...this.request.query, language: { value: this.currentLanguage, isObject: true } };
    }

    this.$emit("changed", this.request);
  },
  methods: {
    setLanguage(locale, country, flag) {
      this.language = locale;
      this.text = country;
      this.flag = flag;

      if (this.indent) {
        this.request.query = { ...this.request.query, [`"${this.indent}.language"`]: { value: this.language, isObject: true } };
      } else {
        this.request.query = { ...this.request.query, language: { value: this.language, isObject: true } };
      }

      this.$emit("changed", this.request);
    },
  },
};
</script>
